// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQ_wrapper__25Glr","description":"FAQ_description__1e8HE","hidden":"FAQ_hidden__2aq66","expandButton":"FAQ_expandButton__pXHsr"};